import { Action } from '@ngrx/store';

export enum ManagerSelectionActionTypes {
  ManagerDealSelection = '[Manager] Manager Deal Selection',
  ManagerDealSelectionMany = '[Manager] Manager Deal Selection Many',
  ManagerDealsSelectionChanged = '[Manager] Manager Deals Selection Changed'
}

export class ManagerDealSelection implements Action {
  public readonly type = ManagerSelectionActionTypes.ManagerDealSelection;
  constructor(public dealId: string, public selected: boolean) {}
}

export class ManagerDealSelectionMany implements Action {
  public readonly type = ManagerSelectionActionTypes.ManagerDealSelectionMany;
  constructor(public dealsSelection: { dealId: string; selected: boolean }[]) {}
}
export class ManagerDealsSelectionChanged implements Action {
  public readonly type =
    ManagerSelectionActionTypes.ManagerDealsSelectionChanged;
  constructor(public dealIds: string[]) {}
}

export type ManagerSelectionActionUnion =
  | ManagerDealSelectionMany
  | ManagerDealsSelectionChanged
  | ManagerDealSelection;
